import axios from "axios";
import { Partner_Service_URL } from "../Url";
import HashMap from "hashmap";
import { clearLogoutData } from "../logout/action";

var map = new HashMap();
var err;
function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}

export const saveResendLinkActions = {
  SAVE_RESEND_LINK_DETAILS_SUCCESS: "SAVE_RESEND_LINK_DETAILS_SUCCESS",
  SAVE_RESEND_LINK_DETAILS_ERROR: "SAVE_RESEND_LINK_DETAILS_ERROR",
};

export function saveResendLinkDetails(props) {
  const { access_token, values, partnerFirmId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Partner_Service_URL}/resendRegistrationLink?partnerFirmId=${partnerFirmId}`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(saveResendLinkSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(saveResendLinkError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(saveResendLinkError(err));
          return err.response;
        }
      });
}

export function saveResendLinkError(error) {
  return {
    type: saveResendLinkActions.SAVE_RESEND_LINK_DETAILS_ERROR,
    payload: error,
  };
}

export function saveResendLinkSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: saveResendLinkActions.SAVE_RESEND_LINK_DETAILS_SUCCESS,
      payload: props,
    });
  };
}
